export default ({ timeString = '00:00', minPastMinutesPerDay, maxPastMinutesPerDay }) => {
  const [hours, min] = timeString.split(':').map(n => Number(n));
  const pastMinutesOfDay = hours * 60 + min;
  return pastMinutesOfDay >= minPastMinutesPerDay && pastMinutesOfDay <= maxPastMinutesPerDay;
};
